class PriceFilterChips extends HTMLElement {
  constructor() {
    super();
    this.gteId = this.dataset.gteId;
    this.lteId = this.dataset.lteId;
    this.mobileGteId = this.dataset.mobileGteId;
    this.mobileLteId = this.dataset.mobileLteId;

    this.querySelectorAll('.price-filter-chip').forEach((chip) => {
      chip.addEventListener('click', () => this.onChipClick(chip));
    });
  }

  onChipClick(chip) {
    const alreadyActive = chip.classList.contains('price-filter-chip--active');

    this.querySelectorAll('.price-filter-chip').forEach((c) => {
      c.classList.remove('price-filter-chip--active');
      c.setAttribute('aria-pressed', 'false');
    });

    const min = alreadyActive ? null : chip.dataset.min;
    const max = alreadyActive ? null : chip.dataset.max;

    if (!alreadyActive) {
      chip.classList.add('price-filter-chip--active');
      chip.setAttribute('aria-pressed', 'true');
    }

    this.applyToInputs(this.gteId, this.lteId, min, max);
    this.applyToInputs(this.mobileGteId, this.mobileLteId, min, max);
  }

  applyToInputs(gteId, lteId, min, max) {
    const gte = gteId && document.getElementById(gteId);
    const lte = lteId && document.getElementById(lteId);
    if (!gte || !lte) return;

    gte.value = min === null ? '0' : min;
    lte.value = max === null ? lte.getAttribute('max') : max;

    gte.dispatchEvent(new Event('input', { bubbles: true }));
    lte.dispatchEvent(new Event('input', { bubbles: true }));
  }
}

customElements.define('price-filter-chips', PriceFilterChips);
